<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-6">
      <form @submit.prevent="submit" >
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="form-group input-group-sm">
          <label >Model telefonu</label>
          <input class="form-control" v-model="form.name"/>
        </div>
        <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
        <router-link class="btn btn-secondary btn-sm" :to="{ name: 'brands' }">Anuluj</router-link>
      </form>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import validator from 'validator'
import un from 'underscore'
import appConfig from '@/service/config'
import flashService from '@/service/flashService'

export default {
  name: 'BrandsNew',
  data: function () {
    return {
      errors: [],
      form: {
        name: ''
      }
    }
  },
  methods: {
    validate () {
      var err = []
      if (validator.isEmpty(this.form.name)) {
        err.push('podaj nazwe')
      }
      return err
    },
    submit: function () {
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/brands',
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        console.log(res.data)
        flashService.add("msg",{
          type: "alert-success",
          text: "Zapisano markę"
        });
        this.$router.push({name: 'brands'})
      }).catch(err => {
        this.errors = un.map(err.response.data.errors, item => {
          return item.message
        })
      })
    }
  },
  created: function () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/brands/BrandsNew.vue